import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { IconButton } from '@/components/icon-button/IconButton'
import { MenuContent, MenuItemGroup, MenuSeparator } from '@/components/menu/MenuContent'
import { MenuItem } from '@/components/menu/MenuItem'
import { OverflowMenu, Edit, MoveToFolder, TrashDelete } from '@/assets/icons'

interface FolderOverflowMenuProps {
  onRename?: () => void
  onMove?: () => void
  onDelete?: () => void
  /** Static note shown below the actions, e.g. "Read only. Managed by Box." for synced folders. */
  footerNote?: string
}

/**
 * FolderOverflowMenu
 *
 * Dropdown menu for folder actions (rename, move, delete).
 */
export function FolderOverflowMenu({ onRename, onMove, onDelete, footerNote }: FolderOverflowMenuProps) {
  const hasActions = Boolean(onRename || onMove || onDelete)
  if (!hasActions && !footerNote) return null

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <IconButton icon={<OverflowMenu />} variant="plain" color="neutral" aria-label="Folder actions" />
      </DropdownMenu.Trigger>

      <MenuContent align="end" alignOffset={-3} side="bottom">
        {hasActions && (
          <MenuItemGroup>
            {onDelete && <MenuItem label="Delete" icon={TrashDelete} onSelect={onDelete} variant="destructive" />}
            {onRename && <MenuItem label="Rename" icon={Edit} onSelect={onRename} variant="neutral" />}
            {onMove && <MenuItem label="Move" icon={MoveToFolder} onSelect={onMove} variant="neutral" />}
          </MenuItemGroup>
        )}
        {footerNote && (
          <>
            {hasActions && <MenuSeparator />}
            <div className="px-3 py-2 text-xs text-brand-neutral-600">{footerNote}</div>
          </>
        )}
      </MenuContent>
    </DropdownMenu.Root>
  )
}
